import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Speakers = () => {
  return (
    <React.Fragment>
      <SEO title="Speakers | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Plenary Speakers &amp; Invited Speakers
        "
        content="For Participants"
        contentTwo="Plenary Speakers &amp; Invited Speakers
        "
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          
          <span>&nbsp;</span>
          <p align="justify">
            <h4>Title: Thoughts on Evolutionary Optimization and Deep Learning</h4>
            <br />
            <h5>Abstract:</h5>
            A new round of scientific and technological revolution and industrial transformation is booming, and some basic scientific problems have given birth to major breakthroughs, which are expected to give birth to new major scientific ideas and scientific theories, and to produce disruptive technologies. Artificial intelligence technology is the main productive force in today&amps;s society, and evolutionary computing methods have also played a huge role. It has achieved remarkable results in many industries and fields, and has huge potential. This report reviews the development of evolutionary learning, focuses on the current research progress of evolutionary learning and optimization, and gives some thoughts on future development combined with some of the team&amps;s work in the direction of evolutionary learning.
            <br></br>
          <h4>Speaker: </h4>
            <br/>




          <p text-align="center">
            <img src="images/avatar/jiao.jpg" alt="Xu" width={159} />
          </p>
          <p text-align="center">
            <strong>
              <div id="name">Dr. Licheng Jiao</div>
              <br />
              IEEE/IET/CAAI/CAA/CIE/CCF Fellow
              <br />
              Distinguished/Chair Professor, Xidian University.
            </strong>
          </p>
            <h5>Biography:</h5>
            Licheng Jiao has been a professor in Xidian University since 1992.
            Now, he is the distinguished/chair/director professor of the Faculty
            of Computer Science and Technology of Xidian University, Dean of AI
            research institute, International Research Center for Intelligent
            Perception and Computation, Key Laboratory of Intelligent Perception
            and Image Understanding of Ministry of Education, Joint
            International Research Laboratory of Intelligent Perception and
            Computation, and National 111 Project Base of Intelligent
            Information Processing. His professional activities include
            IEEE/IET/CAAI/CAA/CIE/CCF Fellow, the member of the International
            Division of Scientific and Technological Committee of the Ministry
            of Education in China, the vice board chairperson of Chinese
            Association of Artificial Intelligence. He is the chairman of IET
            Xi&apos;an Network, the Xi&apos;an Chapter of IEEE Computational
            Intelligence Society, the Award Commission of IEEE Xi&apos;an
            Chapter, and the Xi&apos;an Chapter of IEEE Geoscience and Remote
            Sensing Society. He is the Associate Editor of “IEEE Transactions on
            Geoscience and Remote Sensing”, the Presiding Panelist for the
            Innovative Team in the Ministry of Education, the member of the
            Subject Consultative Group of the State Council and the expert of
            the Undergraduate Teaching Level Evaluation of the Ministry of
            Education, evaluation expert of the National Natural Science
            Foundation Information Division, member of the Assessment Panel of
            National Postdoctoral Management Committees.
          </p>
          <hr />

          {/* a new speaker */}

          <span>&nbsp;</span>
          <span>&nbsp;</span>

          <p align="justify">
            <h4>Title: Qua Vadis AI?</h4>
            <br />
            <h5>Abstract:</h5>
            During the last two decades, profound technological changes have
            occurred around us, supported by disruptive advances both on the
            software and hardware sides. Additionally, we have witnessed a
            cross-fertilization of concepts and an amalgamation of information,
            communication, and control technology-driven approaches. This has
            led to what is termed as digital transformation, i.e., the
            integration of digital technology into all areas of business,
            fundamentally changing how companies operate and deliver value to
            customers. The most recent development is integrating Artificial
            Intelligence (AI) in digital transformation as the primary enabler
            and the facilitator. It is expected that the applications of AI will
            truly transform our world and impact all facets of society, economy,
            living, working, healthcare and technology.
            <br />
            <br />
            The study of artificial intelligence (AI) has been a continuous
            endeavor of scientists and engineers for over 65 years. The simple
            contention is that human-created machines can do more than just
            labor-intensive work; they can develop human-like intelligence. AI
            has been very appealing as it aligns with the nature of human beings
            in terms of their never-satisfied demands for higher productivity on
            the one hand and, on the other hand, the curiosity of how we
            understand and try to change the world. Having gone through several
            historical stages with several winters, AI has become a leading
            technology today and plays novel roles like never. Therefore, it is
            time to discuss the past, the present, and the future of both the AI
            tools and the AI “beings” at this juncture. In this presentation, in
            addition to the technical aspects of AI technology in short to
            mid-term, thoughts and insights are also presented regarding the
            symbiotic relationship of AI and humans in the long run.
          </p>
          <br/>
            <h4>Speaker: </h4>
            <br/>
          <p text-align="center">
            <img src="images/avatar/okyay.jpg" alt="okyay" width={159} />
          </p>
          <strong>
            <div id="name">Prof. Okyay Kaynak</div>
            <br />
              IEEE Fellow
              <br />
            Professor, Bogazici University.
          </strong>
          <br/>
          <br/>

          <p align="justify">
            <h5>Biography:</h5>
            Okyay Kaynak received the B.Sc. degree with first-class honors and
            Ph.D. degrees in electronic and electrical engineering from the
            University of Birmingham, UK, in 1969 and 1972, respectively. <br />
            <br />
            From 1972 to 1979, he held various positions within the industry. In
            1979, he joined the Department of Electrical and Electronics
            Engineering, Bogazici University, Istanbul, Turkey, where he is
            currently a Professor Emeritus, holding the UNESCO Chair on
            Mechatronics. He has held long-term (near to or more than a year)
            Visiting Professor/Scholar positions at various institutions in
            Japan, Germany, the U.S., Singapore, and China. His current research
            interests are in the broad field of intelligent systems. He has
            authored three books, edited five, and authored or co-authored more
            than 450 papers that have appeared in various journals and
            conference proceedings.
            <br />
            <br />
            Dr. Kaynak has served as the Editor in Chief of IEEE Trans. on
            Industrial Informatics, IEEE/ASME Trans. on Mechatronics and as the
            Co-Editor in Chief of IEEE Trans. on Industrial Electronics. He
            presently serves as the Founding Editor-in-Chief of Springer journal
            Discover Artificial Intelligence. Additionally, he is on the
            Editorial or Advisory Boards of several scholarly journals. He has
            received the Chinese Government&apos;s Friendship Award, Humboldt
            Research Prize, Doctor Honoris Causa, Obuda University, Hungary
            (2020) and the Academy Prize of the Turkish Academy of Sciences
            (2020). He is a member of this Academy.
          </p>
          <hr />
          {/* begin a new speaker */}
          <span>&nbsp;</span>
          <span>&nbsp;</span>

          <p align="justify">
            <h4>Title: Adapting swarm intelligent algorithms to specific optimization problems</h4>
            <br />
            <h5>Abstract:</h5>
            The No Free Lunch theorem states that “any two optimization algorithms are equivalent when their performance is averaged across all possible problems”. This means that there is no algorithm able to solve all optimization problems. Some of these problems suffer from high computational costs to be solved. In fact, the application of deterministic algorithms generally provides the final result in a non-polynomial time. Therefore, high complexity problems cannot be solved by using exhaustive methods. Thus, non-deterministic algorithms are applied. A non-deterministic algorithm can exhibit different behaviours on different runs. The non-deterministic algorithms are often used to find an approximation to a solution. Therefore, heuristic approaches are useful to solve such kind of problems. Among heuristic methods, Swarm Intelligent (SI) algorithms can be very useful to solve high complexity optimization problems.<br/><br/>

          This presentation will deal with the main features of Swarm Intelligence and the possibility of adapting SI algorithms to specific optimization problems.
          </p>
          <br/>
          <h4>Speaker: </h4>
          <br/>
          <p text-align="center">
            <img src="images/avatar/danilo_istit.jpg" alt="danilo_istit" width={159} />
          </p>
          <strong>
            <div id="name">Prof. Danilo Pelusi</div>
              <br />
              Associate Professor of Computer Science, University of Teramo.
          </strong>
          <br></br>
          <br></br>

          <p align="justify">
            <h5>Biography:</h5>
            Danilo Pelusi received the Ph.D. degree in Computational Astrophysics from the University of Teramo, Italy. He is an Associate Professor at the Department of Communication Sciences, University of Teramo. Editor of books in Springer and Elsevier, he is/was an Associate Editor of IEEE Transactions on Emerging Topics in Computational Intelligence, IEEE Access and International Journal of Machine Learning and Cybernetics. Guest editor for Elsevier, Springer, MDPI, Hindawi and Inderscience journals, he belongs to the editorial board member of many journals. Keynote speaker and chair of IEEE conferences and inventor of patents on Artificial Intelligence, his research interests include Fuzzy Logic, Neural Networks, Information Theory, Machine Learning and Evolutionary Algorithms.
          </p>

          <br/>
          <hr />

          <br/>

          
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Speakers;
